const routes = [
    {
        path: "/student/slots",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: ""
        }
    }
];

export default routes;
